<template>
  <div>
    <SimulacaoFinalizar ref="finalizar" :value="model" @close="close" @salvar="salvar" />
    <resumo-padrao ref="resumo" :vlr-registro="vlrRegistro"></resumo-padrao>
  </div>
</template>
<script>
export default {
  components: {
    SimulacaoFinalizar: () => import('./SimulacaoFinalizar.vue'),
  },
  props: {
    value: null,
    proposta: Boolean
  },
  data () {
    return {
      model: {},
      IOF_NOTA: 0.001,
    };
  },
  computed: {
    vlrRegistro () {
      return this.mValue.GarantiaSimulacao?.reduce((acc, obj) => acc + obj.VlrRegistro, 0);
    },
    isentaIOF () {
      return this.$api.Estruturadas.isNotaComercial(this.mValue.TipoContratoSigla)
    },
    mValue () {
      return this.value
    }
  },
  methods: {
    submit (callback) {
      const th = this

      if (th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        delete th.model.Codigo

        th.model = {
          ...this.model,
          ...this.mValue,
        }
        this.$emit('input', th.model)

        if (this.proposta) {
          th.$api.Estruturadas.SaveProposta(th, callback)
        } else {
          this.$refs.finalizar.openModal()
        }
      } else {
        this.$refs.finalizar.openModal()
      }
    },
    close (response) {
      if (response) { this.$emit('close', response) }
    },
    salvar (callback) {
      const th = this;

      var dto = th.mValue;
      dto = {
        ...dto,
        ...th.model,
        Chave: th.mValue.DocumentoFederal,
        Nome: th.mValue.Nome,
        Descricao: '',
        ModelJson: JSON.stringify(th.mValue),
        DtExpiracao: th.mValue.DtEmissao,
      };
      th.$api.Simulacao.Persist(dto, 'Codigo').then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          if (response.codigo) {
            th.model.Codigo = response.codigo
            th.model.CodigoUsuario = response.codigoUsuario
            th.model.CodigoEmpresa = response.codigoEmpresa
          }
          callback(th.model.Codigo)
        }
      })
    },
    async load () {
      const th = this;
      if (th.mValue.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        const { PMTIrregular: { Resumo } } = await th.$api.Estruturadas.CalcularFluxoIrregular(th, th.mValue.dtoFluxoIrregular)
        Resumo.Parcelas && Resumo.Parcelas.forEach((item) => {
          item.DtVencimento = item.DtVencimento.split('T')[0]
        })
        th.setModel({ Proposta: Resumo })

        th.mValue.CodigoSimulacao = Resumo.CodigoSimulacao

        return
      }
      const tipoPessoa = th.$api.UI.Format.SomenteNumeros(th.mValue.DocumentoFederal).length === 11 ? 1 : 2

      th.mValue.CodigoOperacao = th.$api.UI.Guid.New();

      const obj = {
        dto: {
          Prazo: th.mValue.Prazo,
          VlrSeguro: (th.mValue.VlrSeguro || 0),
          VlrAvaliacao: (th.mValue.VlrAvaliacao || 0),
          VlrVistoria: (th.mValue.VlrVistoria || 0),
          TipoPessoa: tipoPessoa,
          NroDiasAcrescimo: th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), th.mValue.DtPrimeiroVencto),
          VlrSolicitado: th.mValue.TipoOperacaoCred === 3 ? (th.mValue.VlrProdutoBem - th.mValue.VlrEntrada) : th.mValue.VlrSolicitado,
          VlrTAC: th.mValue.VlrTAC,
          PercJurosNegociado: th.mValue.TxJuros,
          VlrOutrosServicos: th.vlrRegistro
        },
        parametros: []
      };

      if (this.mValue.TipoOperacaoCred === 3) {
        obj.dto.VlrEntrada = th.mValue.VlrEntrada || 0
        obj.dto.VlrProdutoBem = th.mValue.VlrProdutoBem || 0
      }

      if (th.isentaIOF) {
        obj.parametros.push({ Nome: 'PROPOSTA_ISENTARIOF', Valor: true })
        obj.dto.VlrIOF = th.IOF_NOTA
      }

      if (th.mValue.ModeloCalculo === th.$api.Estruturadas.ModeloCalculoEnum.SAC) {
        th.$api.Multiplo.CalculaGridParcelasSimplificadoSAC(obj).then(
          (result) => {
            th.setModel(result)
          }
        );
      } else {
        th.$api.Multiplo.CalculaGridParcelasSimplificadoPrice(obj).then(
          (result) => {
            th.setModel(result)
          }
        );
      }
    },
    async setModel (result) {
      const th = this
      var proposta = {
        ...th.mValue,
        ...result.Proposta
      }
      const totalCredito = Math.round(proposta.VlrTotalCredito * 100) / 100

      if (th.isentaIOF && !Number.isInteger(totalCredito)) {
        th.model = proposta
        await th.$api.Estruturadas.RoundNotaComercial(th, null, true)
        proposta.VlrTAC = th.model.VlrTAC
      }

      let valorTotalSolicitado = (proposta.VlrSolicitado || 0)
      if (proposta.TipoOperacaoCred === 3) { valorTotalSolicitado = (proposta.VlrProdutoBem || 0) - (proposta.VlrEntrada || 0) }
      valorTotalSolicitado += (proposta.VlrTAC || 0) + th.vlrRegistro

      if (proposta.OutrosServicos) { valorTotalSolicitado += (proposta.VlrSeguro || 0) + (proposta.VlrAvaliacao || 0) + (proposta.VlrVistoria || 0) }

      const computedModel = {
        Codigo: th.value.Codigo,
        Situacao: '',
        SituacaoDescricao: '',
        Cliente: {
          ...proposta.Cliente,
          DocumentoFederal: proposta.DocumentoFederal,
          Nome: proposta.Nome
        },
        CodigoCliente: null,
        CodigoSimulacao: proposta.CodigoSimulacao,

        TipoOperacaoCred: proposta.TipoOperacaoCred,
        TipoOperacaoNome: proposta.TipoOperacaoNome,
        TipoCalculoFluxo: proposta.TipoCalculoFluxo,
        TipoContratoDescricao: proposta.TipoContratoDescricao,
        PrimeiraParcela: proposta.Parcelas[0],
        UltimaParcela: proposta.Parcelas[proposta.Parcelas.length - 1],
        Prazo: proposta.Prazo,

        VlrSolicitado: proposta.TipoOperacaoCred === 3 ? (proposta.VlrProdutoBem - proposta.VlrEntrada) : proposta.VlrSolicitado,
        VlrTAC: proposta.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: result.Proposta.VlrIOF || result.Proposta.IOF,
        VlrTotalFinanciado: (result.Proposta.VlrIOF || result.Proposta.IOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: result.Proposta.VlrTotalDivida,

        OutrosServicos: proposta.OutrosServicos,
        VlrSeguro: proposta.VlrSeguro,
        VlrAvaliacao: proposta.VlrAvaliacao,
        VlrVistoria: proposta.VlrVistoria,

        PercIndiceFinan: th.value.PercIndiceFinan,
        PercJurosMensal: result.Proposta.PercJurosMensal || result.Proposta.TxJurosAoMes,
        PercJurosAnual: result.Proposta.PercJurosAnual || result.Proposta.TxJurosAoAno,
        PercCETMensal: result.Proposta.PercCETMensal || result.Proposta.CETaoMes,
        PercCETAnual: result.Proposta.PercCETAnual || result.Proposta.CETaoAno,
        ModeloCalculo: th.value.ModeloCalculo,
        TipoIndexador: th.value.TipoIndexador,
        TipoIndiceFinan: th.value.TipoIndiceFinan,

        Parcelas: proposta.Parcelas,
        GarantiaSimulacao: proposta.GarantiaSimulacao,
        VencimentoPersonalizado: proposta.VencimentoPersonalizado ?? false,
      }

      th.$set(th, 'model', computedModel)
      th.$refs.resumo.load(th.model)
    }
  },
};
</script>
